
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import Snackbar from "@/components/Snackbar.vue";
// Entities
import { Company, Profile } from "@/entities/index";

@Component({
  components: {
    Snackbar,
  },
})
export default class GeneralSettings extends Vue {
  generalSettingsDialog = false;
  client = "";
  clients: Company[] = [];

  limit = null;
  range = [5000, 30000];

  async allClients(): Promise<void> {
    this.clients = (await axios.get(`/api/companies`)).data as Company[];
  }

  mounted() {
    this.allClients();
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);
  }

  showSnackbar(): void {
    const snackbar = this.$refs.snackbarGeneralSettings as Snackbar;
    snackbar.show();
  }

  afterCreate(): void {
    this.clear();
    this.showSnackbar();
  }
}
